module.exports = __webpack_public_path__ + "img/ico-add--white.bb1684fc.svg";